import React, { useState, useEffect } from "react";
import DynamicCard from "../../CustomComponents/DynamicHomeCard";
import Card from "../../../components/CustomComponents/Card";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../../components/CustomComponents/Loader";
import { width } from "../../CustomComponents/Card/CardStyles";
import CustomInput from "../../../components/CustomComponents/FormInputs";
import CustomTextInput from "../../../components/CustomComponents/CustomtextInput";
import RegisterSuccessModal from "../../../components/OnBoard/Signup/RegisterSuccessModal";
import {
  STATUS_SUCCESS_CODE,
  GOOGLE_PLACE_DETAILS_WITH_PLACE_ID,
  GOOGLE_PLACES_AUTO_COMPLETE,
  VALIDATE_ALL_DETAILS_OF_USER,
  GET_BENEFICIARY_DETAILS,
  REMOVE_BENEFICIARY,
  ADD_BENEFICIARY,
  UPDATE_BENEFICIARY,
  REGISTER_USER,
  CONTACT_US_URL,
} from "../../../network/URLConstants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  GetApiHeadersWithBearer,
  GetApiHeadersWithOutBearer,
  PostRequest,
  GetRequest,
} from "../../../network/NetworkUtils";
import {
  displayErrorMessage,
  displaySuccessMessage,
  parseGoogleLocationResponse,
  DisplaySSNMessage,
  validateAuthorizedUser,
} from "../../../utils";
import { formatDateOfBirthForUi, retrieveData } from "../../../helpers/utils/Utils";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import Modal from "../../../components/CustomComponents/Modal";
import { fetchConfigarationData } from "../../../helpers/utils/Utils";
import CustomAlertModel from "../../../components/CustomComponents/CustomAlertModel";
import address_update_Succss from "../../../assets/images/address_update_Succss.png";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../assets/images/arrow.png";
import ArrowLightBlue from "../../../assets/images/Arrow_light_blue.png";
import transactionErrorIcon from "../../../assets/images/transfer-error.png";
import pendingfile from "../../../assets/images/pendingfile.png";
import profileError from "../../../assets/images/profileError.png";
import check from "../../../assets/images/check_3x.png";
import disableCheck from "../../../assets/images/disableCheck.png";
import logFirebaseEvents from "../../../components/LogFirebaseEvents";
import HomeLayout from "../../Layout/HomeLayout";
import { LogoContainer } from "../../Layout/Footer/FooterStyles";
import Logo from "../../../assets/images/home_logo.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
const appConfigData = await fetchConfigarationData();

const CipAccountVerificationDetails = ({
  openPatriotActClick,
  transactionDatas,
}) => {
  const ssnRef = React.createRef();
  const addressRef = React.createRef();
  const InputStyles =
    "font-hanken-grotesk  text-secondary-2 px-4 bg-text-btn placeholder-kudzu-blue lg:text-[16px] md:text-[15px] text-[14px] font-medium focus:outline-none w-full h-[60px]";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(); 
  useDocumentTitle(t('page_title_account_verification'));

  const moment = require("moment");
  //mdoal styles
  const HeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[#2965FB]";
  const SubHeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-secondary-3";
  const SubTittleStylesModal =
    "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal text-[#94C3E8]";

  const [isLoading, setIsLoading] = useState(false);
  const providerIdentifier = useSelector((state) => state.providerIdentifier);
  const personalInfo = useSelector((state) => state.signUpPersonelInfo);
  const provider = useSelector((state) => state.provider);

  //university data
  const studentEmailAddress = useSelector((state) => state.studentEmailAddress);
  const studentUniversityCode = useSelector(
    (state) => state.studentUniversityCode
  );
  const studentUniversityName = useSelector(
    (state) => state.studentUniversityName
  );
  const graduationDate = useSelector((state) => state.graduationDate);

  const [editNameClicked, setEditNameClicked] = useState(false);
  const [editLastNameClicked, setEditLastNameClicked] = useState(false);
  const [editDateOfBirthClicked, setEditDateOfBirthClicked] = useState(false);
  const [editSSNClicked, seteditSSNClicked] = useState(false);
  const [addressEditClicked, setAddressEditClicked] = useState(false);
  const currentYear = new Date().getFullYear();

  const [privacyErromessage, setPrivacyErromessage] = useState("");
  const [selectedFirstName, setSelectedFirstName] = useState("");
  const [selectedLastName, setSelectedLastName] = useState("");
  const [selectedDateOfBirth, setSelectedDateOfBirth] = useState("");
  const [selectedSSN, setSelectedSSn] = useState("");
  const [predictions, setPredictions] = useState([]);
  const [typedValue, setTypedValue] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState("");
  const userId = useSelector((state) => state.userId);
  const singedUpMobileNumber = useSelector((state) => state.signUpMobile);
  const [isElectronicVerifyModalOpen, setIsElectronicVerifyModalOpen] =
    useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [zipCodeError, setZipCodeError] = useState("");

  const [loading, setLoading] = useState(false);
  const [infoMessage, setinfoMessage] = useState("");
  const [responseCode, setResponseCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedAddressLine2, setSelectedAddressLine2] = useState("");
  const [line1AdressFilled, setLine1AdressFilled] = useState(false);
  const [homeAddressToserver, setHomeAddressToserver] = useState("");
  const validationSchema = yup.object().shape({
    firstName: yup.string().required(t("enter_firstName")),
    lastName: yup.string().required(t("enter_lasttName")),
    ssn_no: yup.string().required(t("enter_ssn")),
    address: yup.string().required(t("enter_address")),
    apt_etc: yup.string(),
    city: yup.string().required("Please enter a city"),
    state: yup.string().required("Please enter a state"),
    zip_code: yup.string().required("Please enter a valid zip code"),
  });
  const [isRegisterSucessModalOpen, setRegisterSucessModalModalOpen] =
    useState(false);

  const HighlightMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[#262B3A]";
  const SubHeaderMsgStyles =
    "sm:w-auto w-[200px] font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[500] cursor-pointer pointer-events-none";
  const FailSubHeaderMsgStyles =
    "md:w-[317px] sm:w-[257px] font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";

  const calendarInitialValue = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate())
  const [intialHighlightDate, setInitialHighlightDate] = useState();
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [footerMsg, setFooterMsg] = useState("");
  const [cipStatus, setCipStatus] = useState("");
  const [firstNameError, setfirstNameError] = useState("");
  const [lastNameError, setlastNameError] = useState("");
  const [dateOfBirthError, setDateOfBirthError] = useState("");

  const [SSNoError, setSSNoError] = useState("");
  const [isAddress, setAddress] = useState(personalInfo?.formattedAddress);
  const [AddressError, setAddressError] = useState("");
  const [nameChanged, setnameChanged] = useState(false);
  const [ssnChanged, setSsnChanged] = useState(false);
  const [dobChanged, setDobChanged] = useState(false);
  const [addressChanged, setAddressChanged] = useState(false);
  const [isSSNValid, setIsSSNValid] = useState(false);
  const [uploadDocumentEnableForName, setUploadDocumentEnableForName] = useState(false);
  const [personaInfoObject, setPersonalInfoObject] = useState({
    applicationId:
      personalInfo?.applicationId !== null ? personalInfo?.applicationId : "",
    language: "en",
    username: personalInfo?.usernamem !== null ? personalInfo?.username : "",
    password:
      personalInfo?.password !== undefined &&
        personalInfo?.password !== null &&
        personalInfo?.password !== ""
        ? personalInfo?.password
        : "",
    firstName: personalInfo?.firstName !== null ? personalInfo?.firstName : "",
    lastName: personalInfo?.lastName !== null ? personalInfo?.lastName : "",
    preferredName:
      personalInfo?.preferredName !== null ? personalInfo?.preferredName : "",
    middleInitial: "",
    ssn: personalInfo?.ssn != null ? personalInfo?.ssn : "",
    dateOfBirth:
      personalInfo?.dateOfBirth !== null ? personalInfo?.dateOfBirth : "",
    line1: personalInfo?.line1 !== null ? personalInfo?.line1 : "",
    line2: personalInfo?.line2 !== null ? personalInfo?.line2 : "",
    city: personalInfo?.city !== null ? personalInfo?.city : "",
    state: personalInfo?.state !== null ? personalInfo?.state : "",
    zipCode: personalInfo?.zipCode !== null ? personalInfo?.zipCode : "",
    isEsignAccepted:
      personalInfo?.isEsignAccepted !== null
        ? personalInfo?.isEsignAccepted
        : "",
    IsPrivacyPolicyAccepted:
      personalInfo?.IsPrivacyPolicyAccepted !== null
        ? personalInfo?.IsPrivacyPolicyAccepted
        : "",
    IsCHAgreementAccepted: true,
    formattedAddress:
      personalInfo?.formattedAddress !== null
        ? personalInfo?.formattedAddress
        : "",
    CreateSavings: personalInfo !== null ? personalInfo?.CreateSavings : false,
  });
  const [showPassword, setShowPassword] = useState(true);
  const [ssn, setSSN] = useState(
    personalInfo?.ssn != null ? personalInfo?.ssn : ""
  );
  const [ssnBackup, setSSnBackUp] = useState(
    personalInfo?.ssn != null ? personalInfo?.ssn : ""
  );
  const [isCursorVisible, setCursorVisibility] = useState(false);
  const [isReview, setIsReview] = useState(true);
  const [isUploadDocuments, setIsUploadDocuments] = useState(false);

  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    address: "",
    apt_etc: "",
    ssn_no: "",
  });
  const {
    register,
    formState: { errors },
    setError,
    setValue,
    clearErrors,
    getValues,
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    handleSSNValue(ssnBackup);
  }, [showPassword]);
  const toggleCursor = () => {
    setCursorVisibility(!isCursorVisible);
  };

  const handleSaveClick = async () => {

    console.log(personaInfoObject, "updated profile summary")
    dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: personaInfoObject } });
    navigate('/cipUploadDocument')
  };
  const openRegisterSuccessModalOpen = () => {
    setRegisterSucessModalModalOpen(true);
  };

  const updateNameButtonClicked = async () => {
    if (selectedFirstName.trim() == "") {
      setfirstNameError(t("enter_firstName"));
      return;
    }
    var personalobject = personaInfoObject;
    personalobject.firstName = selectedFirstName;
    setPersonalInfoObject(personalobject);
    setnameChanged(true);
    setEditNameClicked(false);
  };


  const closeMobileVerificationModal = () => {
    setIsElectronicVerifyModalOpen(false);
  };



  const handleContinueClick = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    let headers = await GetApiHeadersWithOutBearer(deviceId);
    const requestObj = {
      applicationId: personaInfoObject.applicationId,
      language: "en",
      username: personaInfoObject.username,
      firstName: personaInfoObject.firstName,
      lastName: personaInfoObject.lastName,
      middleInitial: "",
      ssn: personaInfoObject.ssn.replace(/[*-]/g, ""),
      dateOfBirth: personaInfoObject.dateOfBirth,
      line1: homeAddressToserver.line1 != null ? homeAddressToserver.line1 : "",
      line2: homeAddressToserver.line2 != null ? homeAddressToserver.line2 : "",
      city: homeAddressToserver.city != null ? homeAddressToserver.city : "",
      state: homeAddressToserver.state != null ? homeAddressToserver.state : "",
      zipCode:
        homeAddressToserver.zipCode != null ? homeAddressToserver.zipCode : "",
      isEsignAccepted: personaInfoObject.isEsignAccepted,
      IsPrivacyPolicyAccepted: personaInfoObject.IsPrivacyPolicyAccepted,
      IsCHAgreementAccepted: true,
      CreateSavings:
        personalInfo !== null ? personalInfo?.CreateSavings : false,
    };
    if (
      personaInfoObject.password !== undefined &&
      personaInfoObject.password !== ""
    ) {
      requestObj.password = personaInfoObject.password;
    }
    if (providerIdentifier != null && providerIdentifier != undefined) {
      requestObj.provider = provider;
      requestObj.providerId = providerIdentifier;
    }
    if (global.inviteCode != null && global.inviteCode != undefined) {
      requestObj.inviteCode = global.inviteCode;
    }

    setIsLoading(true);

    var response = await PostRequest(
      REGISTER_USER(userId),
      requestObj,
      headers
    );
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      global.inviteCode = null;
      setIsLoading(false);
      setCipStatus(responseObj.Response.cipStatus);
      if (responseObj.Response.cipStatus == "Success") {
        setIsRegistered(true);
        closeMobileVerificationModal();
        openRegisterSuccessModalOpen();
      } else if (responseObj.Response.cipStatus == "Refer") {
        setIsRegistered(true);
        closeMobileVerificationModal();
        showAlertModal(
          true,
          t("thanks"),
          t("reviewing_profile"),
          t("notify_via_email"),
          true,
          false,
          t("login"),
          "",
          false,
          pendingfile
        );
      }
    } else if (responseObj.ResponseCode === 4122) {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      var messageObject = arrMessages[0];
      const message = messageObject.MessageOrField;
      if (message == "AccountEnrollmentFailed") {
        setIsRegistered(true);
        setErrorMessage(message);
        showAlertModal(
          true,
          t("we_are_sorry"),
          t("unable_to_approve"),
          t("please_contact"),
          true,
          false,
          t("login"),
          "",
          false,
          profileError
        );
      } else {
        const displayText = messageObject.DisplayText;
        showAlertModal(
          true,
          t("oops"),
          displayText,
          "",
          true,
          true,
          t("auth_tryAgain"),
          t("Cancel"),
          true,
          transactionErrorIcon
        );
      }
    } else {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      if (arrMessages.length > 0) {
        var messageObject = arrMessages[0];
        const message = messageObject.DisplayText;
        setIsRegistered(true);
        setErrorMessage(message);
        showAlertModal(
          true,
          t("oops"),
          message,
          "",
          true,
          true,
          t("auth_tryAgain"),
          t("Cancel"),
          true,
          transactionErrorIcon
        );
      }
    }
  };

  useEffect(() => {
    console.log("personaInfoObject", personaInfoObject);
    var object = {
      line1: personaInfoObject.line1 != null ? personaInfoObject.line1 : "",
      line2: personaInfoObject.line2 != null ? personaInfoObject.line2 : "",
      city: personaInfoObject.city != null ? personaInfoObject.city : "",
      state: personaInfoObject.state != null ? personaInfoObject.state : "",
      zipCode:
        personaInfoObject.zipCode != null ? personaInfoObject.zipCode : "",
      countryCode:
        personaInfoObject.countryCode != null
          ? personaInfoObject.countryCode
          : "",
      country:
        personaInfoObject.country != null ? personaInfoObject.country : "",
      cardKey:
        personaInfoObject.cardKey != null ? personaInfoObject.cardKey : "",
    };
    setHomeAddressToserver(object);
    setSelectedFirstName(personaInfoObject.firstName);
    setSelectedLastName(personaInfoObject.lastName);
    setSelectedDateOfBirth(personaInfoObject?.dateOfBirth);
    setSelectedSSn(personaInfoObject.ssn);
  }, [personaInfoObject]);

  const editNameButtonClicked = async () => {
    setinfoMessage("");
    setEditNameClicked(true);
    setEditDateOfBirthClicked(false);
    seteditSSNClicked(false);
    setAddressEditClicked(false);
  };
  const editLastNameButtonClicked = async () => {
    setinfoMessage("");
    setEditLastNameClicked(true);
    setEditDateOfBirthClicked(false);
    seteditSSNClicked(false);
    setAddressEditClicked(false);
  };
  const editDateOfBirthButtonClicked = async () => {
    setinfoMessage("");
    setEditDateOfBirthClicked(true);
    setEditNameClicked(false);
    seteditSSNClicked(false);
    setAddressEditClicked(false);
  };


  const updateLastNameButtonClicked = async () => {
    if (selectedLastName.trim() == "") {
      setlastNameError(t("enter_lasttName"));
      return;
    }
    var personalobject = personaInfoObject;
    personalobject.lastName = selectedLastName;
    setPersonalInfoObject(personalobject);
    setnameChanged(true);
    setEditLastNameClicked(false);
  };

  const updateDateOfBirthButtonClicked = async () => {
    if (selectedDateOfBirth === "") {
      setDateOfBirthError(t('Select  Date Of Birth'))
      return;
    }
    var personalobject = personaInfoObject;
    personalobject.dateOfBirth = formatDateOfBirthForUi(selectedDateOfBirth);
    console.log(personalobject, "date of birth update data")
    setPersonalInfoObject(personalobject);
    setEditDateOfBirthClicked(false);

  }

  const editDobButtonClicked = async () => {
    setinfoMessage("");
    setEditNameClicked(false);
    seteditSSNClicked(false);
    setAddressEditClicked(false);
  };
  const editSSNButtonClicked = async () => {
    setinfoMessage("");
    seteditSSNClicked(true);
    setEditNameClicked(false);
    setAddressEditClicked(false);
    setTimeout(() => {
      const inputElement = document.getElementById("ssn_no");
      if (inputElement) {
        inputElement.focus();
      }
    }, 500);
  };
  const updateSSNButtonClicked = async () => {
    if (selectedSSN.trim() == "") {
      setinfoMessage(t("enter_ssn"));
      return;
    }
    var personalObject = personaInfoObject;
    personalObject.ssn = selectedSSN;
    setPersonalInfoObject(personalObject);
    setSsnChanged(true);
    seteditSSNClicked(false);
  };

  const editAddressClicked = async () => {
    setinfoMessage("");
    clearErrors();
    setAddressEditClicked(true);
    setAddress(personaInfoObject?.line1);
    setValue("address", personaInfoObject?.line1);
    setValue("apt_etc", personaInfoObject?.line2);
    setValue("city", personaInfoObject?.city);
    setValue("state", personaInfoObject?.state);
    setValue("zip_code", personaInfoObject?.zipCode);

    setEditNameClicked(false);
    seteditSSNClicked(false);
    setTimeout(() => {
      const inputElement = document.getElementById("addressInput");
      if (inputElement) {
        inputElement.focus();
      }
    }, 500);
  };

  const updateHomeAddress = async (data) => {
    clearErrors();
    const formData = getValues();

    try {
      if (
        isAddress != "" &&
        formData.city != "" &&
        formData.state != "" &&
        formData.zip_code != ""
      ) {
        clearErrors();
        setAddressError("");
        setCityError("");
        setStateError("");
        setZipCodeError("");
        console.log("formData", formData);
        const formattedAddress1 = `${isAddress && `${isAddress}, `}${formData.apt_etc && `${formData.apt_etc}, `
          }${formData.city && `${formData.city}, `}${formData.state && `${formData.state}, `
          }${formData.zip_code && `${formData.zip_code}`}`;
        const updatePersonalObj = {
          ...personaInfoObject,
          line1: isAddress,
          line2: formData.apt_etc,
          city: formData.city,
          state: formData.state,
          zipCode: formData.zip_code,
          formattedAddress: formattedAddress1,
        };

        setPersonalInfoObject(updatePersonalObj);
        setAddressEditClicked(false);
      } else {
        await validationSchema.validate(data, { abortEarly: false });
      }
      if (!isAddress) setAddressError("Address is required");
      else setAddressError("");
    } catch (error) {
      if (!isAddress) setAddressError("Address is required");
      else setAddressError("");
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          if (typeof err.message === "string") {
            if (err.path === "city") {
              setCityError(err.message);
              if (formData.city) {
                setCityError("");
              }
            } else if (err.path === "state") {
              setStateError(err.message);
              if (formData.state) {
                setStateError("");
              }
            } else if (err.path === "zip_code") {
              setZipCodeError(err.message);
              if (formData.zip_code) {
                setZipCodeError("");
              }
            }
            // Handle other fields if needed
          }
        });
      }
    }
  };

  const closeOTPVerifyModal = () => { };
  const closeModel = () => {
    setShowModel(false);
  };
  const verificationSuccess = (type) => {
    setAddressEditClicked(false);

    if (type == t("old_address")) {
      setAddressEditClicked(true);
    } else if (type == t("new_address")) {
      setAddressEditClicked(false);
      showAlertModal(
        true,
        t("success"),
        t("editAddressSuccessMsg"),
        "",
        true,
        false,
        t("done"),
        "",
        true,
        address_update_Succss
      );
    }
  };
  const verificationFaiure = (type, message) => {
    setinfoMessage(message);
  };
  const closeCustomAlertModal = () => {
    setShowModel(false);
    if (isRegistered) {
      window.location.replace("/");
    }
  };

  const onAcptBtnClick = async () => {
    setShowModel(false);
    if (
      cipStatus == "Refer" ||
      cipStatus == "Success" ||
      subHeaderMsg == t("please_contact")
    ) {
      window.location.replace("/");
    }
  };
  const onCancelBtnClick = () => {
    setShowModel(false);
    navigate("/signup");
  };

  const showAlertModal = (
    showModel,
    highlightMsg,
    headerMsg,
    subHeaderMsg,
    btn1Exists,
    btn2Exists,
    btn1Text,
    btn2Text,
    btn1TypeAcpt,
    modelImage
  ) => {
    setShowModel(showModel);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSSNChange = (event) => {

    const ssnNumber = event.target.value;

    // Remove all non-digit characters from the input
    const ssnNo =
      ssnNumber.length !== 9 ? ssnNumber.replace(/[*-]/g, "") : ssnNumber;
    setSSnBackUp(ssnNo);
    handleSSNValue(ssnNo);
    setSelectedSSn(event.target.value);
    setSSNoError("");
    setinfoMessage("");

    if (ssnNo.length == 9) {
      setSSNoError("");
      handleInputChange(event); // Update the form values
      setIsSSNValid(true);
    }
  };
  function handleSSNValue(value) {
    const formatted = showPassword
      ? formatSecuredValue(value)
      : formatValue(value);
    setSSN(formatted);
  }
  function formatValue(value) {
    const formattedValue = value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d{2})(\d{1,2})/, "$1 - $2 - $3");

    return formattedValue;
  }

  function formatSecuredValue(value) {
    const securedValue = value
      .replace(/[^0-9•]/g, "")
      .replace(/((?:\d|.){3})((?:\d|.){2})((?:\d|.){1,2})/, "$1 - $2 - $3")
      .replace(/[0-9]/g, "•");

    return securedValue;
  }


  const handleAdressChange = () => {
    clearErrors();
    setAddressError("");
    setCityError("");
    setStateError("");
    setZipCodeError("");
  };

  const handleSelect = async (selectedAddress, placeId) => {
    clearErrors();
    setAddressError("");
    setCityError("");
    setStateError("");
    setZipCodeError("");
    const results = await geocodeByAddress(selectedAddress);
    const latLng = await getLatLng(results[0]);

    // Get formatted address using the place ID
    const placeResults = await geocodeByPlaceId(placeId);
    const formattedAddress = placeResults[0].formatted_address;
    const addressComponents = placeResults[0].address_components;
    console.log("addressComponents", addressComponents);
    console.log("formattedAddress", formattedAddress);

    var selectedAddress = parseGoogleLocationResponse(addressComponents);

    const address1 =
      (selectedAddress.streetNumber != null
        ? selectedAddress.streetNumber
        : selectedAddress.sublocality != null
          ? selectedAddress.sublocality
          : selectedAddress.naturalFeature != null
            ? selectedAddress.naturalFeature
            : "") +
      (selectedAddress.route != null ? ` ${selectedAddress.route}` : "");
    if (!address1) setAddressError(t("addressError"));

    setValue("address", address1);
    setAddress(address1);
    setValue("apt_etc", "");
    setValue(
      "city",
      selectedAddress.locality != null ? selectedAddress.locality : ""
    );
    setValue(
      "state",
      selectedAddress.administrativeAreaLevel1 != null
        ? selectedAddress.administrativeAreaLevel1
        : ""
    );
    setValue(
      "zip_code",
      selectedAddress.postalCode != null ? selectedAddress.postalCode : ""
    );

    setPredictions([]);
  };

  const handleBlurEventFName = (e) => {
    if (selectedFirstName.trim() == "")
      setfirstNameError("Legal first name required");
    else setfirstNameError("");
  };
  const handleBlurEventLName = (e) => {
    if (selectedLastName.trim() == "")
      setlastNameError("Legal last name required");
    else setlastNameError("");
  };
  const handleBlurDateOfBirth = (e) => {
    if (selectedDateOfBirth.trim() == "")
      setDateOfBirthError("Legal Prefered name required");
    else setDateOfBirthError("");
  };

  const closeRegisterSuccessModal = () => {
    setRegisterSucessModalModalOpen(false);
  };

  const heading = () => {
    return (
      <>
        <span
          className="font-serif-pro text-[var(--signup-flow-heading-text)] lg:text-[31px] md:text-[26px] sm:text-[21px] text-[25px]
             lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px]"
        >
          {t("great_exclamation")}
        </span>
        <span
          className="font-serif-pro sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)] lg:text-[31px] md:text-[26px] sm:text-[21px] text-[25px]
             lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px]"
        >
          {t("please_review")}
        </span>
      </>
    );
  };

  const handleDateChange = (date) => {
    clearErrors();
    const today = new Date();
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

    if (date > eighteenYearsAgo) {
      // Date of birth is less than 18 years ago
      // Handle the validation error as needed
      setDateOfBirthError('Date of birth should be greater than 18 years ago');
      return;
    }
    else if (date > today) {
      setDateOfBirthError('Date of birth cannot be in the future');
      return;
    }
    else {
      clearErrors('dob'); // Clear the dob field error if it was previously set
      setDateOfBirthError('');
      setSelectedDateOfBirth(date)
      setInitialHighlightDate(date)
    }
  };

  useEffect(() => {
    alert(personaInfoObject.dateOfBirth, "date of birth in account verificariton")
  }, [])

  return (
    <>
      <div className="sm:px-[6%] md:py-10 sm:py-12 sm:mt-0 sm:ml-0 ml-9 mt-8 flex flex-wrap sm:flex-nowrap scroll-mt-0 text-white mb-4 sm:mb-6">
        <LogoContainer>
          <img
            src={Logo}
            className="md:h-[50px] w-[120px] h-[40px] md:w-[150px] cursor-pointer"
            alt="Kudzu Logo"
          />
        </LogoContainer>
      </div>
      <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
        <div className="lg:w-[260px] md:w-[290px] w-[185px] sm:mx-0 ml-[2.5rem]">
          <p
            className="text-white font-normal
    lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] 
    sm:leading-[30px] leading-[31px]
     font-serif-pro   lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10
       border-opacity-[50%]"
          >
            {t("additional_Verification")}
          </p>
        </div>
        <div className="md:w-[150px] sm:w-[70px] w-[0px]"></div>
        <div
          className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
                      animate__animated animate__fadeInRight "
        >
          <DynamicCard
            heading={
              <>
                <span
                  className="relative right-15 font-serif-pro 
            text-white 
            text-[25px] leading-[31px] 
            sm:text-[21px] sm:leading-[29px]
            md:text-[26px] md:leading-[33px]
            lg:text-[31px] lg:leading-[38px]"
                >
                  {t("additional_Verification")}
                </span>
              </>
            }

            header={false}
            CardRadius={true}
            cardWidth={width.allpolicies}
            HeaderRadius={true}
            backgroundColor={"white"}
            isWhite={true}
            HeaderContent={false}
          >
            <div
              className="relative right-16.5 font-serif lg:text-[24px] md:text-[20px] sm:text-[16px] text-[18px]
  lg:leading-[30px] md:leading-[25px] sm:leading-[21px] leading-[23px] mt-8 block"
            >
              {t("Account_Verification")}
            </div>

            <div className="relative right-16.5 lg:my-[2rem] md:my-[1.5rem] my-[1rem]">
              <div className="lg:my-[2rem] md:my-[1.5rem] my-[1rem] mb-4 sm:mb-6">
                <div className="flex sm:flex-row flex-col md:flex-row justify-start items-start w-full gap-4">
                  <div className="flex flex-row gap-1 sm:mb-0">
                    <img
                      src={isReview ? `${check}` : `${disableCheck}`}
                      className="w-[14px] h-[14px] md:w-[20px] md:h-[20px] self-center"
                      alt=""
                    />
                    <p className="font-[600] md:font-[300] sm:font-[400] md:text-[14px] sm:text-[12px] text-[12px] md:leading-[25px] sm:leading-[20px] leading-[20px] font-hanken-grotesk">
                      {t("Review_Info")}
                    </p>
                  </div>
                  <div className="flex flex-row sm:mx-1 md:mx-1 mx-0 mb-4 sm:mb-0">
                    <img
                      src={isUploadDocuments ? `${check}` : `${disableCheck}`}
                      className="w-[14px] h-[14px] md:w-[20px] md:h-[20px] self-center"
                      alt=""
                    />
                    <p className="font-[600] mx-1 md:font-[300] sm:font-[400] md:text-[14px] sm:text-[12px] text-[12px] md:leading-[25px] sm:leading-[20px] leading-[20px] font-hanken-grotesk">
                      {t("Upload_Document")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative right-16.5 border-t-[2.5px] border-[#A3CEBB] pb-10   sm:mx-0 mx-4 "></div>
            <div className="relative right-16.5 sm:w-[90%] w-[264px] sm:mx-0 mx-4">
              <div className="font-serif-pro lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px] md:leading-[25px] sm:leading-[18px] leading-[22px] font-normal text-[#262B3A]">
                <p className="mb-4 sm:mb-8">
                  {t("additional_verification_subHeading")}
                </p>
              </div>
            </div>

            <div className="justify-center sm:items-center flex flex-col pb-20 sm:mx-0 mx-4 ">
              <div className="md:w-[60%] sm:w-[70%] w-[80%] md:pt-12 sm:pt-6 pt-2">
                {/*  Name section*/}

                {/* // first name  section  */}
                {!editNameClicked && (
                  <div className="md:mt-25 mt-15">
                    <p
                      className="relative font-hanken-grotesk text-[#262B3A] uppercase lg:text-[13px] md:text-[13px] 
                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                        opacity-[50%]"
                    >
                      {t("legal_first_name")}
                    </p>

                    <p
                      className="relative ml-4 font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] md:mb-6 mb-2"
                    >
                      {personaInfoObject.firstName}
                    </p>

                    <div className="bg-[#D6E2E8] h-0.5 min-h-1 w-full"></div>

                    <button
                      onClick={() => {
                        editNameButtonClicked();
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          editNameButtonClicked();
                        }
                      }}
                    >
                      {
                        <p
                          onClick={() => {
                            editNameButtonClicked();
                          }}
                          className="pt-5 font-hanken-grotesk text-[#2965FB] md:text-[16px] sm:text-[13px] text-[13px] 
                                                   font-[700]"
                        >
                          {t("edit_Legal_First_Name")}
                        </p>
                      }
                    </button>
                  </div>
                )}

                {/* // First name update section  */}
                {editNameClicked && (
                  <div className="md:mt-16 mt-12">
                    <div className="w-full">
                      <CustomTextInput
                        maxLength={35}
                        autoFocus={true}
                        name={t("first_name_placeholder")}
                        onChange={(event) => {
                          setinfoMessage("");
                          setfirstNameError("");
                          setlastNameError("");
                          setSelectedFirstName(event.target.value);
                        }}
                        onBlur={(e) => handleBlurEventFName(e)}
                        value={selectedFirstName}
                        style={{ width: "100%", height: "51px" }}
                        error={firstNameError}
                      />
                    </div>
                    <button
                      onClick={() => {
                        updateNameButtonClicked();
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          updateNameButtonClicked();
                        }
                      }}
                      className="font-hanken-grotesk text-[#2965FB]
                                            md:text-[16px] sm:text-[13px] text-[13px]  font-[700]"
                    >
                      {t("save")}
                    </button>
                  </div>
                )}

                {/* // last name  section  */}
                {!editLastNameClicked && (
                  <div className="md:mt-20 mt-12">
                    <p
                      className="font-hanken-grotesk text-[#262B3A] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                                opacity-[50%]"
                    >
                      {t("legal_last_name")}
                    </p>

                    <p
                      className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] md:mb-6 mb-2"
                    >
                      {personaInfoObject.lastName}
                    </p>

                    <div className="bg-[#D6E2E8] h-0.5 min-h-1 w-full"></div>

                    <button
                      onClick={() => {
                        editLastNameButtonClicked();
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          editLastNameButtonClicked();
                        }
                      }}
                    >
                      {
                        <p
                          onClick={() => {
                            editLastNameButtonClicked();
                          }}
                          className="pt-5 font-hanken-grotesk text-[#2965FB] md:text-[16px] sm:text-[13px] text-[13px] 
                                                   font-[700]"
                        >
                          {t("edit_Legal_Last_Name")}
                        </p>
                      }
                    </button>
                  </div>
                )}

                {/* //last name update section */}

                {editLastNameClicked && (
                  <div className="md:mt-16 mt-12">
                    <div className="w-full">

                      <CustomTextInput
                        maxLength={35}
                        autoFocus={true}
                        name={t("last_name_placeholder")}
                        onChange={(event) => {
                          setinfoMessage("");
                          setfirstNameError("");
                          setlastNameError("");
                          setSelectedLastName(event.target.value);
                        }}
                        onBlur={(e) => handleBlurEventLName(e)}
                        error={lastNameError}
                        value={selectedLastName}
                        style={{ width: "100%", height: "51px" }}
                      />
                    </div>

                    <button
                      onClick={() => {
                        updateLastNameButtonClicked();
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          updateLastNameButtonClicked();
                        }
                      }}
                      className="font-hanken-grotesk text-[#2965FB]
                                            md:text-[16px] sm:text-[13px] text-[13px]  font-[700]"
                    >
                      {t("save")}
                    </button>
                  </div>
                )}

                {/* Date of Birth  section */}
                {!editDateOfBirthClicked &&
                  <div className='md:mt-20 mt-12'>
                    <p className='font-hanken-grotesk text-[#262B3A] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                                opacity-[50%]'>{t("date_of_birth_placeholder")}</p>

                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] md:mb-6 mb-2">
                      {personaInfoObject.dateOfBirth}

                    </p>

                    <div className="bg-[#D6E2E8] h-0.5 min-h-1 w-full"></div>

                    <button
                      onClick={() => { editDateOfBirthButtonClicked() }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          editDateOfBirthButtonClicked()
                        }
                      }}>{<p onClick={() => { editDateOfBirthButtonClicked() }}
                        className='pt-5 font-hanken-grotesk text-[#2965FB] md:text-[16px] sm:text-[13px] text-[13px] 
                                                   font-[700]'>{t("edit_dob")}</p>}</button>
                  </div>
                }

                {/* Date of Birth  update section*/}
                {editDateOfBirthClicked &&
                  <div className='md:mt-16 mt-12'>
                    <DatePicker
                      selected={intialHighlightDate}
                      highlightDates={calendarInitialValue}
                      onChange={handleDateChange}
                      value={personaInfoObject.dateOfBirth}
                      openToDate={calendarInitialValue}
                      dateFormat="MMMM d, yyyy"
                      name="dob" // Pass the `name` prop directly
                      label={t("dob_title")}
                      placeholderText={t("date_of_birth_placeholder")}
                      className='font-hanken-grotesk 
                                        text-secondary-2 px-4 py-2
                                            bg-text-btn placeholder-kudzu-blue 
                                            text-sm font-medium focus:outline-none w-full h-[60px] placeholder:font-semibold'
                      showMonthDropdown
                      showYearDropdown
                      autoComplete='off'
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      maxDate={new Date(currentYear, 11, 31)}

                    />
                    <div className='mb-4 mt-4'>
                      {dateOfBirthError && (
                        displayErrorMessage(dateOfBirthError)
                      )}
                    </div>

                    <button
                      onClick={() => { updateDateOfBirthButtonClicked() }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          updateDateOfBirthButtonClicked()
                        }
                      }}
                      className='font-hanken-grotesk text-[#2965FB]
                                            md:text-[16px] sm:text-[13px] text-[13px]  font-[700]'>{t("save")}</button>
                  </div>
                }

                {/* phone section */}

                {/* email section */}

                {/*  address section */}
                {!addressEditClicked && (
                  <div className="md:mt-16 mt-12">
                    <p
                      className="font-hanken-grotesk text-[#262B3A] uppercase 
                                          lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px]  font-[600] tracking-[2px] md:pb-8 pb-4 
                                opacity-[50%]"
                    >
                      {t("personal_address")}
                    </p>

                    <p
                      className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[16px] 
                                    font-medium leading-[26px] md:mb-6 mb-2"
                    >
                      {personaInfoObject.formattedAddress}
                    </p>

                    <div className="bg-[#94C3E8] h-0.5 min-h-1 w-full"></div>

                    <button
                      onClick={() => {
                        editAddressClicked();
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          editAddressClicked();
                        }
                      }}
                    >
                      {
                        <p
                          onClick={() => {
                            editAddressClicked();
                          }}
                          className="pt-5 font-hanken-grotesk text-[#2965FB] font-[700] 
               sm:text-[12px] text-[14px] md:text-[16px]"
                        >
                          <span className="block md:hidden">
                            {t("edit_address")}
                          </span>
                          <span className="hidden md:block">
                            {t("update_address")}
                          </span>
                        </p>
                      }
                    </button>
                  </div>
                )}

                {/*  address  update section */}
                {addressEditClicked && (
                  <div className="md:mt-16 mt-12">
                    <PlacesAutocomplete
                      ref={addressRef}
                      value={isAddress}
                      onChange={(value) => {
                        setAddress(value);
                        if (value) {
                          setAddressError("");
                          setCityError("");
                          setStateError("");
                          setZipCodeError("");
                        }
                      }}
                      onSelect={handleSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <input
                            ref={addressRef}
                            id="addressInput"
                            {...getInputProps({ placeholder: "Address" })}
                            className="font-hanken-grotesk text-secondary-2 px-4 py-2 bg-text-btn placeholder-kudzu-blue text-sm font-medium focus:outline-none w-full h-[60px]"
                            onBlur={(e) => {
                              if (!isAddress)
                                setAddressError("Address is required");
                              else setAddressError("");
                            }}
                          />
                          <div className="mb-4">
                            {loading ? <div>Loading...</div> : null}
                            {suggestions.map((suggestion) => {
                              const style = {
                                backgroundColor: suggestion.active
                                  ? "#ffffff"
                                  : "#F5F8F9",
                                cursor: "pointer",
                                padding: "8px",
                                fontSize: "16px",
                                fontWeight: "500",
                                lineHeight: "26px",
                              };
                              return (
                                <div
                                  key={suggestion.placeId}
                                  {...getSuggestionItemProps(suggestion, {
                                    style,
                                  })}
                                >
                                  {suggestion.description}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                    {AddressError && displayErrorMessage(AddressError)}
                    {predictions.length > 0 && (
                      <ul className="bg-[aliceblue] max-h-60 overflow-y-auto p-2">
                        {predictions.map((prediction) => (
                          <li
                            key={prediction.place_id}
                            className="font-hanken-grotesk text-sm font-medium leading-6 p-2 cursor-pointer"
                            value={prediction.place_id}
                          >
                            {prediction.description}
                          </li>
                        ))}
                      </ul>
                    )}
                    {addressEditClicked &&
                      infoMessage &&
                      responseCode === STATUS_SUCCESS_CODE && (
                        <div className="mb-2">
                          {displaySuccessMessage(infoMessage)}
                        </div>
                      )}
                    {addressEditClicked &&
                      infoMessage &&
                      responseCode !== STATUS_SUCCESS_CODE && (
                        <div className="mb-2">
                          {displayErrorMessage(infoMessage)}
                        </div>
                      )}
                    <span
                      className="pt-1 text-[var(--text-clr-transactions)] font-hanken-grotesk lg:text-[18px] md:text-[17px] 
             sm:text-[15px] text-[15px] font-medium"
                    >
                      {t("P.O._boxes_are_not_accepted")}{" "}
                    </span>
                    <CustomInput
                      name="apt_etc"
                      label={t('apt_suite_etc')}
                      placeholder={t("optional_placeholder")}
                      register={register}
                      error={errors.apt_etc}
                      type="text"
                    />
                    <CustomInput
                      name="city"
                      label={t("City")}
                      placeholder={t("City_placeholder")}
                      register={register}
                      error={errors.city}
                      type="text"
                      onChange={handleAdressChange}
                    />
                    <div className="mb-2">
                      {cityError && displayErrorMessage(cityError)}
                    </div>

                    <CustomInput
                      name="state"
                      label={t("State")}
                      placeholder={t("State_placeholder")}
                      register={register}
                      error={errors.state}
                      type="text"
                      onChange={handleAdressChange}
                    />
                    <div className="mb-2">
                      {stateError && displayErrorMessage(stateError)}
                    </div>

                    <CustomInput
                      name="zip_code"
                      label={t("Zip_code")}
                      placeholder={t("Zip_code_placeholder")}
                      register={register}
                      error={errors.zip_code}
                      type="text"
                      onChange={handleAdressChange}
                    />
                    <div className="mb-2">
                      {zipCodeError && displayErrorMessage(zipCodeError)}
                    </div>
                    <button
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          updateHomeAddress();
                        }
                      }}
                      onClick={() => {
                        updateHomeAddress();
                      }}
                      className="font-hanken-grotesk text-[#2965FB]
                                         md:text-[16px] text-[12px] font-[700]"
                    >
                      {t("save")}
                    </button>
                  </div>
                )}

                {/*  ssn eidt  section*/}
              </div>
            </div>

            {infoMessage && responseCode === STATUS_SUCCESS_CODE && (
              <div className="mb-2">{displaySuccessMessage(infoMessage)}</div>
            )}

            {/* save and back section */}

            <div
              className={`flex flex-row justify-end lg:mt-20 md:mt-16 
                    sm:mt-10 mt-10 sm:mx-0 mx-4 sm:mb-20 mb-10 md:-mr-10 ${addressEditClicked || editNameClicked
                  ? "opacity-50"
                  : "opacity-100"
                }`}
            >
              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600]
                                lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#2965FB]
                                 cursor-pointer flex items-center"
                onClick={() => {
                  if (!addressEditClicked && !editNameClicked) {
                    handleSaveClick();
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key == "Enter") {
                    event.preventDefault();
                    if (!addressEditClicked && !editNameClicked) {
                      handleSaveClick();
                    }
                  }
                }}
              >
                {t("next")}
                <img
                  src={
                    !addressEditClicked && !editNameClicked
                      ? Arrow
                      : ArrowLightBlue
                  }
                  className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                  alt="Arrow"
                />
              </button>
            </div>
          </DynamicCard>

          <Modal
            isOpen={isRegisterSucessModalOpen}
            onClose={closeRegisterSuccessModal}
            isLogo={false}
            title={null}
            subtitle={null}
            content={
              <div>
                <RegisterSuccessModal
                  subtitle={
                    personalInfo?.CreateSavings == true
                      ? t("spending_saving_account_ready")
                      : t("spending_account_ready")
                  }
                />
              </div>
            }
          />

          <CustomAlertModel
            isOpen={showModel}
            onClose={closeCustomAlertModal}
            image={modelImage}
            highlightMsg={
              headerMsg == t("reviewing_profile") ? (
                <p
                  className="font-serif-pro modal-title  sm:flex block flex-col
                lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px]
                 sm:leading-[30px] leading-[37px] font-normal text-[#2965FB] cursor-pointer pointer-events-none"
                >
                  {highlightMsg}
                  {headerMsg == t("reviewing_profile") ? (
                    <span
                      className="md:w-[287px] sm:w-[200px] font-serif-pro modal-title
                lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px]
                leading-[37px] font-normal cursor-pointer pointer-events-none text-[#262B3A]"
                    >
                      {" "}
                      {headerMsg}
                    </span>
                  ) : (
                    <span className={HeaderMsgStyles}>{headerMsg}</span>
                  )}{" "}
                </p>
              ) : (
                <p className={HighlightMsgStyles}>{highlightMsg}</p>
              )
            }
            HeaderMsg={
              headerMsg != t("reviewing_profile") && (
                <p className={`${HeaderMsgStyles} md:w-[357px] sm:w-[335px]`}>
                  {headerMsg}
                </p>
              )
            }
            subHeaderMsg={
              subHeaderMsg == t("please_contact") ? (
                <p className={FailSubHeaderMsgStyles}>
                  {t("please_contact")}
                  {
                    <button
                      onClick={() => {
                        window.open(CONTACT_US_URL, "_blank");
                      }}
                      className="font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] text-[#2965FB] font-semibold cursor-pointer md:ml-1"
                    >
                      {t("signup_customer_care")}
                    </button>
                  }
                  {t("for_access")}
                </p>
              ) : (
                <p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>
              )
            }
            btn1Exists={btn1Exists}
            btn2Exists={btn2Exists}
            btn1Text={btn1Text}
            btn2Text={btn2Text}
            btn1TypeAcpt={btn1TypeAcpt}
            verificationFailure={() => { }}
            footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
            onAcptBtnClick={onAcptBtnClick}
            onCancelBtnClick={onCancelBtnClick}
          />

          {isLoading && <Loader />}
        </div>
      </div>
    </>
  );
};

export default CipAccountVerificationDetails;